import { Link } from "react-router-dom";

export default function TurismoHero() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-end overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dominican%20Republic%20aerial%20panoramic%20view%20stunning%20turquoise%20Caribbean%20sea%20white%20sand%20beaches%20lush%20tropical%20mountains%20Punta%20Cana%20Samana%20coastline%20paradise%20island%20aerial%20photography%20golden%20hour%20dramatic%20sky&width=1920&height=1080&seq=turismo-hero-main&orientation=landscape"
        alt="Turismo en República Dominicana"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#071529]/90 via-[#071529]/40 to-transparent" />

      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-4 md:px-6 pb-16 md:pb-20">
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/25 rounded-full px-5 py-2 mb-5 backdrop-blur-sm">
          <i className="ri-map-pin-line text-emerald-400 text-sm w-4 h-4 flex items-center justify-center" />
          <a
            href="https://es.godominicanrepublic.com/"
            target="_blank"
            rel="nofollow noreferrer"
            className="text-white/80 text-xs font-semibold tracking-widest uppercase hover:text-emerald-300 transition-colors cursor-pointer"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            República Dominicana
          </a>
        </div>
        <h1
          className="text-white font-extrabold leading-tight mb-4 tracking-tight"
          style={{ fontFamily: "'Sora', sans-serif", fontSize: "clamp(2.5rem, 6vw, 5rem)" }}
        >
          TURISMO RD
        </h1>
        <p className="text-white/65 text-base md:text-lg max-w-2xl leading-relaxed" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          Todo lo que mueve el turismo en la isla.
        </p>
      </div>
    </section>
  );
}